import React, { useEffect, useState } from "react";
import { api, errorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { useI18n } from "@/lib/i18n";

export default function SaveToDialog({ candidate, onClose }) {
  const { t } = useI18n();
  const [lists, setLists] = useState([]);
  const [projects, setProjects] = useState([]);
  const [name, setName] = useState("");
  useEffect(() => {
    if (!candidate) return;
    api.get("/lists").then((r) => setLists(r.data));
    api.get("/projects").then((r) => setProjects(r.data));
  }, [candidate]);
  const run = async (fn, msg) => {
    try { await fn(); toast.success(msg); onClose(); } catch (e) { toast.error(errorDetail(e)); }
  };
  const newList = () => run(async () => {
    const { data } = await api.post("/lists", { name, shared: true });
    await api.post(`/lists/${data.id}/members`, { candidate_id: candidate.id });
  }, t("Saved to new list"));
  return (
    <Dialog open={!!candidate} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="save-to-dialog">
        <DialogHeader><DialogTitle>{t("Save {{name}}", { name: candidate?.full_name })}</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div>
            <div className="eyebrow mb-2">{t("Recruitment projects")}</div>
            <div className="space-y-1">
              {projects.map((p) => <button key={p.id} data-testid={`save-to-project-${p.id}`} onClick={() => run(() => api.post(`/projects/${p.id}/entries`, { candidate_id: candidate.id }), t("Added to {{name}}", { name: p.title }))} className="w-full text-left text-sm rounded-md border px-3 py-2 hover:bg-muted">{p.title}</button>)}
              {!projects.length && <p className="text-xs text-muted-foreground">{t("No projects yet.")}</p>}
            </div>
          </div>
          <div>
            <div className="eyebrow mb-2">{t("Talent lists")}</div>
            <div className="space-y-1">
              {lists.map((l) => <button key={l.id} data-testid={`save-to-list-${l.id}`} onClick={() => run(() => api.post(`/lists/${l.id}/members`, { candidate_id: candidate.id }), t("Saved to {{name}}", { name: l.name }))} className="w-full text-left text-sm rounded-md border px-3 py-2 hover:bg-muted">{l.name} <span className="text-muted-foreground">({l.count})</span></button>)}
            </div>
            <div className="flex gap-2 mt-2">
              <Input value={name} onChange={(e) => setName(e.target.value)} placeholder={t("New list name")} data-testid="new-list-name" />
              <Button onClick={newList} disabled={!name.trim()} data-testid="create-list-and-save">{t("Create & save")}</Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
